module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/f2oyR0/tc-custom/9781504085403.jpg?1726519033301",
      "alt": "This image is the cover for the book Replacement"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Replacement\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Your husband had an affair. What do you do when the woman who destroyed your marriage asks for your help? A new thriller from the “hugely engrossing” author (Catherine Ryan Howard, Edgar Award finalist).")]), _c('br'), _c('br'), _vm._v(" Lauren Wade hates Jem Carter, and Jem hates her. So, when Lauren gets a message from Jem asking for help, she suspects it’s some sort of attention-seeking stunt by the woman she caught in bed with her husband. Lauren decides to simply alert her ex, Daniel, who thinks Lauren is the one trying to cause trouble."), _c('br'), _c('br'), _vm._v(" However, when Jem’s car is found abandoned on a bridge, the police become involved . . ."), _c('br'), _c('br'), _vm._v(" Lauren knows she’s been a bit erratic. She’s acted in fits of jealousy at times. But she hasn’t harmed Jem. With DS Bekah Bradley closing in, Lauren must make a desperate attempt to find out what happened to Jem—before she becomes a missing person herself . . ."), _c('br'), _c('br'), _vm._v(" “Wildly entertaining and compelling.” —"), _c('i', [_vm._v("Daily Mail")]), _c('br'), _c('br'), _vm._v(" “I was hooked from the first page. This is a book that pulls you in and demands that you read on. . . . Prepare yourself for a rollercoaster ride of emotions. Can’t recommend highly enough.” —Helen H. Durrant, bestselling author"), _c('br'), _c('br'), _vm._v(" “Tense and gripping.” —Sanjida Kay, author of "), _c('i', [_vm._v("My Mother’s Secret")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jacqueline Ward\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0